// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__36AVc","container":"styles_container__s2bq5","title":"styles_title__3MMe4","wrapper":"styles_wrapper__P-vfR","answer":"styles_answer__KD8TN"};